import Layout from '@/components/feature/Layout';

export default function TerminosPage() {
  return (
    <Layout>
      {/* Hero header with image background */}
      <div className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=clean%20minimalist%20legal%20office%20desk%20with%20documents%20and%20a%20fountain%20pen%2C%20warm%20natural%20lighting%20from%20a%20window%2C%20professional%20editorial%20photography%2C%20soft%20shadows%2C%20neutral%20earthy%20tones%2C%20simple%20composition%20with%20space%20for%20text&width=1800&height=600&seq=terminos-hero-legal&orientation=landscape"
            alt="Documentos legales"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
        </div>
        <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-300 mb-3">
            Legal
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Términos de Uso
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Condiciones y lineamientos para el uso de nuestros servicios digitales.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-8">
            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                1. Aceptación de los Términos
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Al acceder y utilizar el sitio web de CODESAJAN, usted acepta estos términos de uso en su totalidad. Si no está de acuerdo con alguno de estos términos, le solicitamos que no utilice nuestro sitio web ni nuestros servicios digitales.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                2. Uso del Servicio
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Nuestros servicios digitales están destinados exclusivamente a usuarios afiliados al Comité de Desarrollo San Jacinto Norte Zona Oeste. El usuario se compromete a proporcionar información veraz y actualizada al momento de realizar consultas, pagos u otros trámites a través de nuestra plataforma. El uso indebido de los servicios digitales, incluyendo intentos de acceso no autorizado, podrá dar lugar a la suspensión del servicio.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                3. Propiedad Intelectual
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Todo el contenido presente en este sitio web, incluyendo textos, imágenes, logotipos y diseño, es propiedad exclusiva de CODESAJAN. Queda prohibida su reproducción total o parcial sin autorización previa por escrito de la directiva del comité.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                4. Limitación de Responsabilidad
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                CODESAJAN no se hace responsable por interrupciones temporales del servicio digital causadas por factores externos como fallas en la conexión de internet, cortes de energía eléctrica o mantenimiento programado de la plataforma. El usuario acepta que la información mostrada en las consultas de deuda es de carácter referencial y debe ser validada en oficinas para trámites definitivos.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                5. Modificaciones
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                CODESAJAN se reserva el derecho de modificar estos términos de uso en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en este sitio web. Se recomienda a los usuarios revisar periódicamente esta sección.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                6. Contacto
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Para mayor detalle sobre estos términos, consultas legales o cualquier aspecto relacionado con la reglamentación interna del comité, comuníquese directamente con la directiva de CODESAJAN a través de nuestros canales oficiales de atención.
              </p>
            </section>

            <div className="mt-12 p-6 rounded-xl bg-accent-50 border border-accent-100">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center shrink-0 mt-0.5"></i>
                <div>
                  <p className="text-sm font-semibold text-foreground-950 mb-1">Información Importante</p>
                  <p className="text-sm text-foreground-600">
                    Este documento presenta un resumen general de nuestros términos. Para información detallada, requisitos legales completos y reglamentación específica, le solicitamos contactar directamente con la directiva de CODESAJAN en nuestras oficinas durante el horario de atención.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}